<template>
	<div>
		<div class="container container--small pdt-50 ">
				<div class="t-headline10 font-b mgb-8 pdl-24 pdr-24">{{$t('1598')}}</div>
				<div class="t-body1 t-color-bodyGrayA font-r mgt-8 pdl-24 pdr-24">{{$t('1599')}}</div>
				<div class="mdc-card  mgt-24 mgl-24 mgr-24 mgb-16">
					<div class="pdt-13 pdl-24 pdb-24 pdr-24">
						<div class="mdc-form-field  d-flex w-full flex-row-reverse checkbox-rtl" @keypress="focusActive('checkbox-1')">
							<div class="mdc-checkbox mgr--10">
								<input type="checkbox" class="mdc-checkbox__native-control"
								 id="checkbox-1"
								 v-model="checkTerms"
								 @change="handleCheckAll1"
								 tabindex="0"
								/>
								<div class="mdc-checkbox__background check-red" tabindex="0">
									<svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
										<path class="mdc-checkbox__checkmark-path" fill="none"
											d="M1.73,12.91 8.1,19.28 22.79,4.59" />
									</svg>
									<div class="mdc-checkbox__mixedmark"></div>
								</div>
								<div class="mdc-checkbox__ripple"></div>
							</div>
							<label for="checkbox-1"><router-link tabindex="0" to="/terms" class="pdt-2 font-m t-subtitle3 pdl-0 t-color-headlineBlack">{{$t('1600')}}</router-link></label>
						</div>
						<router-link tabindex="0" to="/terms">
						<div class="mgt-16 t-body3 font-r t-color-bodyGrayA t-line-h-26 h-180 scroll-y cursor--pointer pda-24 bg-documentGray" v-html="htmlTermsOfService" >
						</div>
						</router-link>
						<div class="mgt-16 t-body3 font-r t-color-bodyGrayA t-line-h-26">
							<!-- {{$t('178',{'str1':termsYear,'str2':termsMonth,'str3':termsDay})}} -->
							{{$t('178')}} : {{termsDate}}
						</div>
					</div>
				</div>
				<div class="mdc-card  mgt-24 mgl-24 mgr-24 mgb-16" @keypress="focusActive('checkbox-2')">
					<div class="pdt-13 pdl-24 pdb-24 pdr-24">
						<div class="mdc-form-field  d-flex w-full flex-row-reverse checkbox-rtl">
							<div class="mdc-checkbox mgr--10">
								<input type="checkbox"
									class="mdc-checkbox__native-control"
									id="checkbox-2"
									v-model="checkPrivacy"
									@change="handleCheckAll2"
									tabindex="0"
								/>
								<div class="mdc-checkbox__background check-red" tabindex="0">
									<svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
										<path class="mdc-checkbox__checkmark-path" fill="none"
											d="M1.73,12.91 8.1,19.28 22.79,4.59" />
									</svg>
									<div class="mdc-checkbox__mixedmark"></div>
								</div>
								<div class="mdc-checkbox__ripple"></div>
							</div>
							<label for="checkbox-2">
								<router-link tabindex="0" to="/privacy" class="pdt-2 font-m t-subtitle3 pdl-0 t-color-headlineBlack">{{$t('1601')}}</router-link>
							</label>
						</div>
						<router-link tabindex="0" to="/privacy">
							<div class="mgt-16 t-body3 font-r t-color-bodyGrayA t-line-h-26 h-180 scroll-y cursor--pointer pda-24 bg-documentGray" v-html="htmlPrivacypolicy">
							</div>
						</router-link>
						<div class="mgt-16 t-body3 font-r t-color-bodyGrayA t-line-h-26">
							{{$t('179')}} : {{privacyDate}}
						</div>
					</div>
				</div>
				<div class="mgt-16 pdl-24 pdr-16">
					<div class="mdc-form-field  d-flex w-full flex-row-reverse checkbox-rtl" @keypress="focusActive('checkbox-3')">
						<div class="mdc-checkbox mgr-1">
						 <input
							type="checkbox"
							class="mdc-checkbox__native-control"
							id="checkbox-3"
							v-model="checkAll"
							@change="handleCheckAll"
							:checked="validAgree"
							tabindex="0"
							/>
							<div class="mdc-checkbox__background check-red" tabindex="0">
								<svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
									<path class="mdc-checkbox__checkmark-path" fill="none"
										d="M1.73,12.91 8.1,19.28 22.79,4.59" />
								</svg>
								<div class="mdc-checkbox__mixedmark"></div>
							</div>
							<div class="mdc-checkbox__ripple"></div>
						</div>
						<label for="checkbox-3" class="font-m t-subtitle3 mgr-16">{{$t('1602')}}</label>
					</div>
				</div>
				<div class="mgt-50 mgb-50 pdl-24">
					<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText mgr-8"  @click="next()" @keypress="next()" tabindex="0">
						<div class="mdc-button__ripple"></div>
						<span class="mdc-button__label t-body2 font-r">{{$t('1603')}}</span>
					</button>
					<button class="mdc-button  bg-white t-color-secondaryBtnText" @click="cancelJoin" @keypress="cancelJoin" tabindex="0">
						<div class="mdc-button__ripple"></div>
						<span class="mdc-button__label t-body2 font-r">{{$t('1604')}}</span>
					</button>
				</div>
							 <!-- <router-view></router-view> -->
			</div>
	</div>
</template>

<script>
/**
 * 회원가입 - 약관동의 컴포넌트(sign up - pp & tnu component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCSelect} from '@material/select';
import {MDCFormField} from '@material/form-field'
import {MDCCheckbox} from '@material/checkbox';
import {MDCRadio} from '@material/radio'
import {MDCRipple} from '@material/ripple'
import joinApi from '@/api/joinApi.js'
import {mapState, mapMutations} from 'vuex'
import {joinMixin} from '@/mixins/join.js'

export default {
	data() {
		return {
			checkTerms: false,
			checkPrivacy: false,
			checkAll: false,
			htmlPrivacypolicy: null,
			htmlTermsOfService: null,
			termsYear: '',
			termsMonth: '',
			termsDay: '',
			privacyYear: '',
			privacyMonth: '',
			privacyDay: '',
			privacyDate: '',
			termsDate: ''
		}
	},

	mixins: [joinMixin],

	created() {
		if (!this.join.joinStart) {
			this.moveJoin2Intro()
		}
	},

	mounted() {
		// get terms & privacy contents
		this.setMaterialUi()
		joinApi.terms().then((response) => {
			const termsUrl = response.data.data.TERMS_OF_SERVICE;
			const privacyUrl = response.data.data.PRIVACY_STATEMENT;

			joinApi.policyContents(termsUrl,'text').then((response) => {
				this.htmlTermsOfService = response.data
			})

			joinApi.policyContents(privacyUrl,'text').then((response) => {
				this.htmlPrivacypolicy = response.data
			})
		}).catch((err) => {
		})

		let privacyParams = {type:'PRIVACY_STATEMENT'};
		joinApi.termsDate(privacyParams).then((response) => {
			if(response.data.data){
				this.privacyDate = this.$moment(response.data.data).format("L")
				//console.log(this.$moment(response.data.data).format("YYYY"))
				this.privacyYear = this.$moment(response.data.data).format("YYYY");
				this.privacyMonth = this.$moment(response.data.data).format("MM");
				this.privacyDay = this.$moment(response.data.data).format("DD");
			}
		}).catch((err) => { console.log('err=>',err)})

		let termsParams = {type:'TERMS_OF_SERVICE'};
		joinApi.termsDate(termsParams).then((response) => {
			if(response.data.data){
				this.termsDate = this.$moment(response.data.data).format("L")
				this.termsYear = this.$moment(response.data.data).format("Y");
				this.termsMonth = this.$moment(response.data.data).format("MM");
				this.termsDay = this.$moment(response.data.data).format("DD");
			}
		}).catch((err) => { console.log('err=>',err)})
	},

	computed: {
		...mapState('join',{
			join : state => state,
		}),

		validAgree() {
			this.checkAll = this.checkTerms && this.checkPrivacy
			return this.checkAll
		}
	},


	methods: {
		// cancelJoin(){
		// 	this.$router.go(-1);
		// },
		gotoPage(routerLink) {
			this.$router.push(routerLink);
		},
		// Store 변이 정의(define store mutation)
		...mapMutations('join', ['SET_TERMS']),

		setMaterialUi() {
			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})
		},

		handleCheckAll1() {
			this.checkTerms
			this.checkPrivacy

		},
		handleCheckAll2() {
			this.checkTerms
			this.checkPrivacy

		},

		// check all
		handleCheckAll() {
			// console.log('checkTerms',this.checkTerms)
			// console.log('checkPrivacy',this.checkPrivacy)
			if (this.checkAll) {
				this.checkTerms = true
				this.checkPrivacy = true
			}else {
				this.checkTerms = false
				this.checkPrivacy = false
			}
		},

		// next
		next() {
			if (this.checkAll) {
				let agreeDate = Date.now()
				this.SET_TERMS(agreeDate)

				if (this.join.socialLink.type === 'google' || this.join.socialLink.type === 'facebook' || this.join.socialLink.type === 'firebase') {
					this.$router.push({
						name: 'Join2Responsibility',
					})
				}else {
					this.$router.push({
						name: 'Join2Responsibility'
					})
				}
			}else {
				this.$snackOpen({
					contents:this.$t('946'), //모든 약관에 동의해 주세요.
					btnDisplay: ''
				}).then(() => {})
			}
		},
		focusActive(id) {
			let toActive = document.querySelector('.mdc-checkbox__background');
			toActive.classList.toggle('radio-active');
			if (!document.querySelector(".mdc-checkbox__background").focus()) {
				document.querySelector("#"+id).click();
				// alert('yes')
			}
			},
	}
}
</script>
<style scoped>
.mdc-form-field > label{
	padding-left: 0px!important;
}
html[dir="rtl"] .mdc-form-field > label{
	padding-right: 0px!important;
}
.cursor--pointer{
	cursor: pointer;
}
</style>
